import React from 'react';
import AiSkeleton, { SkeletonText } from '../../common/AiSkeleton';

/**
 * FAQ 전용 스켈레톤 리스트.
 * FaqAccordion과 유사한 형태로 둥근 모서리와 레이아웃을 모사합니다.
 */
const FaqListSkeleton = ({ count = 3 }) => {
    return (
        <div className="bg-white border border-gray-100 rounded-3xl shadow-sm overflow-hidden divide-y divide-gray-100">
            {Array.from({ length: count }).map((_, i) => (
                <div key={i} className="px-6 py-6 flex items-center justify-between gap-4">
                    <div className="flex items-center gap-4 flex-1">
                        {/* Q 아이콘 위치 */}
                        <AiSkeleton variant="circle" className="w-6 h-6 flex-shrink-0" />
                        {/* 제목 위치 */}
                        <div className="flex-1 space-y-2">
                            <SkeletonText width="60%" className="h-4" />
                        </div>
                    </div>
                    {/* 우측 쉐브론 아이콘 위치 */}
                    <AiSkeleton variant="rect" className="w-5 h-5 rounded-md" />
                </div>
            ))}
        </div>
    );
};

export default FaqListSkeleton;
